import axios from 'axios';

export const masterApi = axios.create({
	baseURL: `${process.env.REACT_APP_BASE_URL}/Maestro`,
});
